import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haSurveysearchPipe'
})
export class HaSurveysearchPipePipe implements PipeTransform {

  transform(roleData: any[],  searchTerm: string): any[] {
    if (!roleData || !searchTerm) { return roleData; }
    return roleData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTerm.toLowerCase().trim()) !== -1
     
    



    );
  }

}
